import { NavItemWrapper, NavWrapper } from '../center-admin/styles';
import { Nav } from 'react-bootstrap';
import { XmListType } from '@nkr/store/xm-tracking';
import { IListItem, IXmTrackingCenterCounts } from '@nkr/models/index';
import { XmStatus, XmType } from '@nkr/enums/index';

interface IProps {
    listType: XmListType,
    counts: IXmTrackingCenterCounts,
    currentStatus: XmStatus,
    currentType: XmType,
    statusList: IListItem[],
    xmTypeList: IListItem[],
    onTabChange: (listType: XmListType) => void
}

const CenterTabs = (props: IProps) => {
    let requestedBy = props.counts != null ? props.counts.requestedBy : 0;
    let requestedFrom = props.counts != null ? props.counts.requestedFrom : 0;
    let history = props.counts != null ? props.counts.history : 0;
    let all = props.counts != null ? props.counts.all : 0;
    let missingFinalXm = props.counts != null ? props.counts.missingFinalXm : 0;

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <NavWrapper width='initial'>
                <div>
                    <Nav bsStyle='pills' bsSize='sm' className='acc-pills' activeKey={props.listType} onSelect={(tab: any) => props.onTabChange(tab)}>
                        <NavItemWrapper eventKey={XmListType.RequestedBy}>Requested by Your Center ({requestedBy})</NavItemWrapper>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper eventKey={XmListType.RequestedFrom}>Requested From Your Donors ({requestedFrom})</NavItemWrapper>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper eventKey={XmListType.MissingFxm}>Missing Final XM's ({missingFinalXm})</NavItemWrapper>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper eventKey={XmListType.History}>History ({history})</NavItemWrapper>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper eventKey={XmListType.All}>All ({all})</NavItemWrapper>
                    </Nav>
                </div>
            </NavWrapper>
        </div>
    );
}

export default CenterTabs;